import { Component, Mixins, Vue } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import { debounce } from '@/utils/util'
import { getTaskType } from '@/utils/order'
import CompanySearchTree from '@/mixins/companySearchTree'
import AreaSearchTree from '@/mixins/areaSearchTree'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

@Component({})
export default class ListMixins extends Mixins(
	CompanySearchTree,
	AreaSearchTree
) {
	// 列表页mixins,有表格搜索相关属性和方法

	public selectedRowKeys: any = []
	public selected: any = []
	public searchForm: any = ''
	public searchLoading: boolean = false
	public current: number = 1
	public total: number = 0
	public pageSizeOptions: any[] = ['10', '20', '30', '40', '50', '80', '100']
	public list: any[] = []
	public pageSize: number = 10
	public moment: Function = moment
	public currentDate: any = new Date()
	public dateFormat: string = 'YYYY-MM-DD'

	public get commonTasktypeMap(): any {
		return Object.assign(
			{},
			this.$store.state.setting.injuredTasktypeMap,
			this.$store.state.setting.surveryTasktypeMap,
			this.$store.state.setting.conciliationTasktypeMap
		)
	}

	public created() {
		this.searchForm = this.$form.createForm(this)
	}

	public onRowChange(rowKey: any, rows: any) {
		this.selectedRowKeys = rowKey
		this.selected = rows
	}

	public resetSelected() {
		this.selectedRowKeys = []
		this.selected = []
	}

	public resetFieldsAndSelected() {
		this.searchForm.resetFields()
		this.resetSelected()
	}

	public resetFields() {
		this.searchForm.resetFields()
	}

	public resetPage() {
		this.current = 1
	}

	public getList() {
		return Promise.resolve()
	}

	public getTaskType(row: any) {
		return getTaskType(row, this.$store.state.setting)
	}

	public getSearchValues(options: any = {}) {
		let form = cloneDeep(this.searchForm.getFieldsValue())
		const { bool2num } = options
		for (const i in form) {
			if (typeof form[i] === 'string') {
				form[i] = form[i].trim()
			}
			if (!form[i] && form[i] !== 0) {
				delete form[i]
			}
			if (bool2num !== false) {
				if (typeof form[i] === 'boolean') {
					form[i] = Number(form[i])
				}
			}
		}

		// 所在区域支持搜索树，需要特别调整值
		if (form.areaCode) {
			console.log(form.areaCode)
			let temp =
				typeof form.areaCode.value === 'string'
					? form.areaCode.value.trim()
					: form.areaCode.value
			form.areaCode = temp
			if (temp) {
				form.area = temp
			} else {
				delete form.areaCode
			}
		}

		if (form.area) {
			let temp =
				typeof form.area.value === 'string'
					? form.area.value.trim()
					: form.area.value
			if (temp) {
				form.area = temp
			} else {
				delete form.area
			}
		}

		form = {
			...form,
			pageSize: this.pageSize,
			pageNum: this.current,
		}
		return form
	}

	public onTableChange(page: any) {
		this.current = page.current
		this.pageSize = page.pageSize
		this.getList()
	}

	public onSearch() {
		this.resetPage()
		this.searchLoading = true
		this.getList().finally(() => {
			this.searchLoading = false
		})
	}
}
